<template>
  <div>
    <v-btn
      x-small
      color="primary"
      outlined
      @click="openCollectionUsersDialog(collectionUsers.id)">
      <template v-if="colUsers.length == 0">
        Aucun responsable assigné
      </template>
      <template v-else-if="colUsers.length == 1">
        {{ colUsers.length }} responsable assigné
      </template>
      <template v-else>
        {{ colUsers.length }} responsables assignés
      </template>
    </v-btn>
    <v-dialog
      transition="dialog-top-transition"
      v-model="collectionUsersDialogId === collectionUsers.id"
      max-width="500px">
      <v-card>
        <v-card-title>
          <div class="d-flex align-center flex-wrap w-100 justify-space-between">
            <p> Responsables de {{ collectionUsers.name }} </p>
            <collection-user-form v-model="collectionUsers.id" @collection-user-updated="fetchCollectionUsers"></collection-user-form>
          </div>
        </v-card-title>
        <v-card-text>
          <v-card
            class="mx-auto"
            max-width="500"
          >
            <v-simple-table
            dense
            >
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Assistant
                  </th>
                  <th class="text-left">
                    Quota
                  </th>
                  <th class="text-left w-[50px]">
                    -
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="item in colUsers"
                  :key="item.id"
                >
                  <td>{{ item.user.name }}</td>
                  <td> {{ item.quota }}%</td>
                  <td>
                    <v-icon
                      size="20"
                      color="error"
                      @click="confirmDelete(item)"
                    >
                      {{ icons.mdiMinusCircle }}
                    </v-icon>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="closeCollectionUsersDialog">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 300 : '100%'"
    >
      <v-card>
        <v-card-title>{{ $t('Confirmer') }}</v-card-title>
        <v-divider />
        <v-card-text>{{ $t('Confirmez-vous le retrait de la collection ?') }}</v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            small
            outlined
            @click="deleteDialog = false"
          >
            {{ $t('Non') }}
          </v-btn>
          <v-spacer />
          <v-btn
            :loading="loading"
            small
            color="primary"
            @click="removeUser"
          >
            {{ $t('Oui') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { computed, defineComponent, onMounted, ref } from '@vue/composition-api'
import { mdiMinusCircle } from '@mdi/js'
import axios from '@axios'
import CollectionUserForm from '@/views/apps/collections/CollectionUserForm.vue'

export default defineComponent({
  name: 'CollectionUsers',
  components: { CollectionUserForm },
  model: {
    prop: 'modelValue',
  },
  props: {
    modelValue: {
      type: [Object, Array],
      default: null,
    },
  },
  setup(props, { emit }) {
    const collectionUsers = computed({
      get: () => props.modelValue,
      set: val => {
        emit('input', val)
      },
    })

    const colUsers = ref([])
    const loading = ref(true)
    const deleteDialog = ref(false)
    const deleteItem = ref(null)
    const collectionUsersDialogId = ref(null)

    onMounted(async () => {
      if (props.modelValue) {
        fetchCollectionUsers(props.modelValue.id)
      }
    })

    function openCollectionUsersDialog(id) {
      collectionUsersDialogId.value = id
    }

    function closeCollectionUsersDialog() {
      collectionUsersDialogId.value = null
    }

    function fetchCollectionUsers(id) {
      loading.value = true
      axios.get(`collection-users/${id}`)
        .then(response => {
          colUsers.value = response.data
          loading.value = false
        }).catch(() => {
        loading.value = false
      })
    }

    function confirmDelete(item) {
      deleteItem.value = item
      deleteDialog.value = true
    }

    function removeUser() {
      loading.value = true
      axios.post('collection-remove-user/',
        {
          user_id: deleteItem.value.user_id,
          collection_id: props.modelValue.id,
        })
        .then(response => {
          fetchCollectionUsers(props.modelValue.id)
          loading.value = false
          deleteDialog.value = false
        }).catch(() => {
        loading.value = false
        deleteDialog.value = false
      })
    }

    return {
      collectionUsers,
      colUsers,
      deleteDialog,
      collectionUsersDialogId,
      openCollectionUsersDialog,
      closeCollectionUsersDialog,
      confirmDelete,
      removeUser,
      fetchCollectionUsers,
      loading,
      icons: { mdiMinusCircle },
    }
  },
})
</script>

<style scoped lang="scss">

</style>
